.heroWrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.35rem;
}

.postExpenseBanner {
  background: linear-gradient(135deg, rgba(134, 242, 228, 0.35) 0%, #eff4ff 100%);
  border: 1px solid rgba(0, 106, 97, 0.35);
  border-radius: 14px;
  padding: 1.15rem 1.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  box-shadow: var(--shadow-card);
}

.postExpenseTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
  background: rgba(134, 242, 228, 0.28);
  border: 1px solid rgba(0, 106, 97, 0.28);
  border-radius: 12px;
  padding: 0.55rem 0.85rem;
}

.postExpenseBadge {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.78rem;
  font-weight: 700;
  color: #005049;
  background: rgba(134, 242, 228, 0.55);
  padding: 0.25rem 0.65rem;
  border-radius: 999px;
}

.dismissBtn {
  background: #ffffff;
  border: 1px solid #c5c5d3;
  color: #444651;
  font-size: 0.8rem;
  font-weight: 700;
  border-radius: 6px;
  padding: 0.18rem 0.55rem;
  cursor: pointer;
}

.postExpenseMainGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 0.85rem;
  align-items: center;
}

.postExpenseStatBox {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 10px;
  padding: 0.75rem 0.95rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.postExpenseStatLabel {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #444651;
  font-weight: 600;
}

.postExpenseStatBig {
  font-size: 1.45rem;
  font-weight: 800;
  color: #0d1c2e;
  font-family: var(--font-display, sans-serif);
  font-variant-numeric: tabular-nums;
}

.postExpenseStatHighlight {
  color: #006a61;
}

.postExpenseActions {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  flex-wrap: wrap;
}

.detailToggleLink {
  background: #eff4ff;
  border: 1px solid #d5e3fc;
  color: #00236f;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.42rem 0.85rem;
  border-radius: 8px;
  cursor: pointer;
}

.primaryCard {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 20px;
  padding: 1.5rem 1.7rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  box-shadow: var(--shadow-card);
  position: relative;
  overflow: hidden;
}

.primaryCard::before {
  content: '';
  position: absolute;
  top: -70px;
  right: -70px;
  width: 240px;
  height: 240px;
  background: radial-gradient(circle, rgba(134, 242, 228, 0.32) 0%, rgba(134, 242, 228, 0) 70%);
  filter: blur(28px);
  pointer-events: none;
}

.headerRow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
}

.eyebrow {
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #006a61;
  display: block;
  margin-bottom: 0.25rem;
}

.title {
  font-family: var(--font-display, sans-serif);
  font-size: 1.28rem;
  font-weight: 800;
  color: #0d1c2e;
  margin: 0;
  letter-spacing: -0.02em;
}

.subtitle {
  font-size: 0.84rem;
  color: #444651;
  margin: 0.2rem 0 0 0;
  line-height: 1.45;
}

.flowShortcuts {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
}

.desktopReviewBadge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #eff4ff;
  border: 1px solid #d5e3fc;
  color: #00236f;
  border-radius: 9px;
  padding: 0.52rem 0.85rem;
  font-size: 0.76rem;
  font-weight: 700;
}

.flowBtnPrimary {
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  border: 1px solid #00236f;
  border-radius: 10px;
  padding: 0.58rem 0.98rem;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 35, 111, 0.18);
}

.flowBtnPrimary:hover {
  background: linear-gradient(135deg, #163280 0%, #24449e 100%);
}

/* El botón de tomar foto rápida está orientado exclusivamente a la vista de celular */
.mobileCameraCta {
  display: none;
}

@media (max-width: 900px) {
  .headerRow {
    display: none;
  }
}

.flowBtnSecondary {
  background: #eff4ff;
  color: #00236f;
  border: 1px solid #d5e3fc;
  border-radius: 10px;
  padding: 0.58rem 0.95rem;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.flowBtnSecondary:hover {
  background: #e6eeff;
  border-color: #b6c4ff;
}

.emptySetupPrompt {
  background: linear-gradient(135deg, rgba(134, 242, 228, 0.25), #eff4ff);
  border: 1px dashed rgba(0, 106, 97, 0.45);
  border-radius: 14px;
  padding: 1rem 1.15rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.85rem;
  flex-wrap: wrap;
}

.emptySetupText {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.82rem;
  color: #444651;
  flex: 1;
  min-width: 220px;
}

.emptySetupText strong {
  color: #00236f;
  font-size: 0.88rem;
}

.emptySetupActions {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  flex-wrap: wrap;
}

.metricsRow {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
  min-width: 0;
  position: relative;
  z-index: 1;
}

.metricBlock {
  background: #f8f9ff;
  border: 1px solid #dce9ff;
  border-radius: 14px;
  padding: 1.05rem 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
}

.metricLabelRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.metricLabel {
  font-size: 0.74rem;
  font-weight: 700;
  color: #444651;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  line-height: 1.3;
  word-break: break-word;
}

.privacyToggleBtn {
  background: #ffffff;
  border: 1px solid #d5e3fc;
  color: #00236f;
  border-radius: 999px;
  padding: 0.16rem 0.6rem;
  font-size: 0.7rem;
  font-weight: 700;
  cursor: pointer;
}

.privacyToggleBtn:hover {
  background: #eff4ff;
}

.metricBigValue {
  font-family: var(--font-display, sans-serif);
  font-size: 2.15rem;
  font-weight: 800;
  color: #00236f;
  font-variant-numeric: tabular-nums;
  line-height: 1.12;
  letter-spacing: -0.03em;
  word-break: break-word;
}

.metricPercentAccent {
  color: #006a61;
}

.metricPercentWarning {
  color: #b45309;
}

.metricPercentDanger {
  color: #ba1a1a;
}

.metricSubtext {
  font-size: 0.79rem;
  color: #444651;
  font-variant-numeric: tabular-nums;
  line-height: 1.38;
  word-break: break-word;
}

.progressSection {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  min-width: 0;
  position: relative;
  z-index: 1;
}

.progressLabels {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.35rem;
  font-size: 0.79rem;
  color: #444651;
  font-variant-numeric: tabular-nums;
}

.progressLabels strong {
  color: #00236f;
}

.progressBarTrack {
  width: 100%;
  height: 12px;
  background: #e6eeff;
  border-radius: 999px;
  overflow: hidden;
  border: 1px solid #dce9ff;
}

.progressBarFill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.3s ease;
}

.fillOptimal {
  background: linear-gradient(90deg, #00236f 0%, #006a61 100%);
}

.fillWarning {
  background: linear-gradient(90deg, #d97706 0%, #f59e0b 100%);
}

.fillDanger {
  background: linear-gradient(90deg, #ba1a1a 0%, #ef4444 100%);
}

@media (max-width: 900px) {
  .primaryCard {
    padding: 1rem 1.05rem;
    gap: 0.85rem;
  }

  .metricsRow {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.75rem;
  }

  .metricBlock {
    padding: 0.85rem 0.95rem;
  }

  .metricBigValue {
    font-size: 1.72rem;
  }

  .progressLabels {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.2rem;
    font-size: 0.74rem;
  }
}


/* ============================================================================
   Control Inteligente de Tarjetas (Máx. 3) & Monitor Multi-Ciclo
   ============================================================================ */
.cardsControlPanel {
  background: #f8f9ff;
  border: 1px solid #dce9ff;
  border-radius: 16px;
  padding: 1.15rem 1.3rem;
  display: flex;
  flex-direction: column;
  gap: 0.95rem;
  min-width: 0;
  position: relative;
  z-index: 1;
}

.cardsPanelHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.cardsPanelEyebrow {
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #006a61;
  display: block;
}

.cardsPanelTitle {
  font-family: var(--font-display, sans-serif);
  font-size: 1rem;
  font-weight: 800;
  color: #0d1c2e;
  margin: 0.15rem 0 0 0;
}

.configCardsBtn {
  background: #ffffff;
  border: 1px solid #d5e3fc;
  color: #00236f;
  border-radius: 9px;
  padding: 0.46rem 0.85rem;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(13, 28, 46, 0.04);
}

.configCardsBtn:hover {
  background: #eff4ff;
  border-color: #b6c4ff;
}

.advisorBanner {
  background: linear-gradient(135deg, rgba(134, 242, 228, 0.28) 0%, #eff4ff 100%);
  border: 1px solid rgba(0, 106, 97, 0.32);
  border-radius: 14px;
  padding: 0.9rem 1.05rem;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.advisorBannerNextCycle {
  background: linear-gradient(135deg, #e6eeff 0%, #eff4ff 100%);
  border-color: #b6c4ff;
}

.advisorMain {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.advisorTopRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.advisorBadge {
  font-size: 0.69rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #005049;
}

.advisorDirectSpendInfo {
  font-size: 0.75rem;
  color: #444651;
  font-variant-numeric: tabular-nums;
}

.advisorDirectSpendInfo strong {
  color: #0d1c2e;
}

.advisorHeadline {
  font-family: var(--font-display, sans-serif);
  font-size: 0.95rem;
  font-weight: 800;
  color: #00236f;
}

.advisorDetail {
  font-size: 0.8rem;
  color: #444651;
  margin: 0;
  line-height: 1.44;
}

.tacticalStrategyBox {
  margin-top: 0.25rem;
  background: #ffffff;
  border-left: 3px solid #00236f;
  border-radius: 8px;
  padding: 0.55rem 0.78rem;
  font-size: 0.78rem;
  color: #0d1c2e;
  font-weight: 600;
  line-height: 1.4;
  box-shadow: 0 2px 6px rgba(13, 28, 46, 0.04);
}

.limitAlertsStack {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.limitAlertItem {
  background: #ffdad6;
  border: 1px solid rgba(186, 26, 26, 0.35);
  border-radius: 10px;
  padding: 0.68rem 0.88rem;
  font-size: 0.8rem;
  font-weight: 700;
  color: #93000a;
  line-height: 1.4;
}

.noCardsBox {
  background: #ffffff;
  border: 1px dashed #b6c4ff;
  border-radius: 12px;
  padding: 0.9rem 1.05rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.noCardsText {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.8rem;
  color: #444651;
  flex: 1;
  min-width: 220px;
}

.noCardsText strong {
  color: #0d1c2e;
  font-size: 0.86rem;
}

.cardsGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
  gap: 0.95rem;
  min-width: 0;
}

/* Emulador físico de Tarjeta de Crédito Sapphire Institutional */
.cardItemBox {
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 54%, #002d48 100%);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-top-width: 3px;
  border-radius: 16px;
  padding: 1rem 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.72rem;
  min-width: 0;
  color: #ffffff;
  box-shadow: 0 14px 28px rgba(0, 35, 111, 0.18);
  position: relative;
  overflow: hidden;
}

.cardItemRecommended {
  border-color: #86f2e4;
  box-shadow: 0 14px 30px rgba(0, 106, 97, 0.24);
}

.cardItemAtLimit {
  border-color: #ffdad6;
}

.cardItemTop {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.cardAliasRow {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  flex-wrap: wrap;
}

.cardColorDot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.28);
}

.cardAlias {
  font-family: var(--font-display, sans-serif);
  font-size: 0.94rem;
  font-weight: 800;
  color: #ffffff;
}

.recommendedPill {
  font-size: 0.65rem;
  font-weight: 800;
  padding: 0.12rem 0.48rem;
  border-radius: 999px;
  background: rgba(134, 242, 228, 0.22);
  border: 1px solid rgba(134, 242, 228, 0.45);
  color: #86f2e4;
}

.cardBankSub {
  font-size: 0.73rem;
  color: #dce9ff;
  display: block;
  margin-top: 0.12rem;
}

.cardChipRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  padding: 0.15rem 0;
}

.cardChipEmulator {
  width: 32px;
  height: 22px;
  border-radius: 4px;
  background: linear-gradient(135deg, #fde68a 0%, #f59e0b 100%);
  border: 1px solid rgba(255, 255, 255, 0.35);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25);
  flex-shrink: 0;
}

.cardMaskedNumber {
  font-family: var(--font-mono, monospace);
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  color: rgba(255, 255, 255, 0.92);
  font-variant-numeric: tabular-nums;
}

.cardContactlessIcon {
  font-family: var(--font-mono, monospace);
  font-size: 0.78rem;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.65);
}

.billingOpenBadge {
  font-size: 0.68rem;
  font-weight: 800;
  padding: 0.2rem 0.52rem;
  border-radius: 6px;
  background: rgba(134, 242, 228, 0.18);
  border: 1px solid rgba(134, 242, 228, 0.45);
  color: #86f2e4;
}

.billingClosedBadge {
  font-size: 0.68rem;
  font-weight: 800;
  padding: 0.2rem 0.52rem;
  border-radius: 6px;
  background: rgba(204, 229, 255, 0.18);
  border: 1px solid rgba(204, 229, 255, 0.42);
  color: #cce5ff;
}

.cardDatesHighlightBox {
  background: rgba(0, 0, 0, 0.24);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 10px;
  padding: 0.55rem 0.7rem;
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  font-size: 0.74rem;
  color: #dce9ff;
}

.cardDateLine {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.cardDateLine strong {
  color: #ffffff;
  font-family: var(--font-mono, monospace);
}

.cardSpendProgressBlock {
  display: flex;
  flex-direction: column;
  gap: 0.38rem;
}

.cardSpendAmountsRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
  flex-wrap: wrap;
  font-size: 0.76rem;
  color: #dce9ff;
  font-variant-numeric: tabular-nums;
}

.cardSpendAmountsRow strong {
  color: #ffffff;
}

.cardPctNormal {
  font-family: var(--font-mono, monospace);
  font-weight: 700;
  color: #86f2e4;
}

.cardPctDanger {
  font-family: var(--font-mono, monospace);
  font-weight: 800;
  color: #ffdad6;
}

.cardMiniBarTrack {
  width: 100%;
  height: 7px;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.cardMiniBarFill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.25s ease;
  background: linear-gradient(90deg, #86f2e4 0%, #34d399 100%);
}

.cardSubBreakdownRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
  flex-wrap: wrap;
  font-size: 0.71rem;
  color: #dce9ff;
  font-variant-numeric: tabular-nums;
}

.cardSubBreakdownRow strong {
  color: #ffffff;
}

.cardNextCycleTag {
  color: #86f2e4;
}

.nextCycleMonitorBar {
  background: linear-gradient(135deg, #eff4ff 0%, #e6eeff 100%);
  border: 1px solid #b6c4ff;
  border-radius: 12px;
  padding: 0.85rem 1.05rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.nextCycleMonitorLeft {
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
  flex: 1;
  min-width: 210px;
}

.nextCycleMonitorTitle {
  font-family: var(--font-display, sans-serif);
  font-size: 0.86rem;
  font-weight: 800;
  color: #00236f;
}

.nextCycleMonitorSub {
  font-size: 0.75rem;
  color: #444651;
  line-height: 1.38;
}

.nextCycleMonitorRight {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.15rem;
}

.nextCycleAmountBig {
  font-family: var(--font-display, sans-serif);
  font-size: 1.25rem;
  font-weight: 800;
  color: #00236f;
  font-variant-numeric: tabular-nums;
}

.nextCycleShareBadge {
  font-size: 0.72rem;
  font-weight: 700;
  color: #006a61;
  font-variant-numeric: tabular-nums;
}
